
import { Component } from '@angular/core';
import {
    ActivatedRoute,
    NavigationEnd,
    Router,
    RouterModule,
} from '@angular/router';
import { User } from '../../models/User';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { TranslationStatusComponent } from '../translation-status/translation-status.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-header',
    standalone: true,
    imports: [
    RouterModule,
    LanguageSelectorComponent,
    TranslationStatusComponent,
    TranslateModule
],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
})
export class HeaderComponent {
    showBackToHome = false;
    me?: User;

    constructor(private router: Router, private authService: AuthService) {}

    async ngOnInit() {
        if (this.authService.isLogged()) {
            try {
                this.me = await firstValueFrom(
                    this.authService.getUserInfoOrRefreshIfNeeded()
                );
            } catch (e) {
                console.log(e);
            }
        }

        this.checkShowBackToHomeBasedOnCurrentUrl();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.checkShowBackToHomeBasedOnCurrentUrl();
            }
        });
    }

    private checkShowBackToHomeBasedOnCurrentUrl() {
        const currentUrl = this.router.url;
        let shouldShow = true;

        if (this.me !== undefined) {
            if (this.me.is_parent || this.me.is_teacher) {
                shouldShow = currentUrl !== '/hometp' && currentUrl !== '/';
            } else {
                shouldShow = currentUrl !== '/homec' && currentUrl !== '/';
            }
        }

        this.showBackToHome = shouldShow;
    }
}
